export default "__VITE_ASSET__DcEzAIAB__"